import React, { useState, useEffect } from "react";
import axios from 'axios';
import {Button, Table } from 'react-bootstrap';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import DoorIcon from '@material-ui/icons/MeetingRoom';
import PopupComponent from "../util/NewGatePopup";
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import Pagination from "react-js-pagination";
import pagiarray from 'paginate-array';
import SelectCenter from "../util/SelectCenter";
import { useSelector, useDispatch } from 'react-redux';
import { faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GetApiHost from '../util/GetApiHost';
import moment from 'moment';

var activePage = 1;
var totalCount = 0; //총회원수
const pageSize = 10;
var gateData = '';

let storage = {
    popupMode : '',
    popupData : {}
}

function NewGate() {
    const [gateInfo, setGateInfo] = useState([]);
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    
    function openPopup(mode, data) {
        setShowPopup(true);
        storage.popupMode = mode;
        storage.popupData = data;
    }

    function closePopup(isUpdated) {
        setShowPopup(false);
        if(isUpdated === "updated"){
            activePage = 1;
            getGateInfo()
        }
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handlePageChange(changepage) {
        activePage = changepage;
        const page = activePage;
        const pageCurrent = pagiarray(gateData,page,pageSize);
        
        totalCount = gateData.length;

        setGateInfo(pageCurrent.data);
    }

    async function getGateInfo(){
        var temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        const api_host = GetApiHost();
        const result = await axios.post(api_host + '/admin/gate_info', {
            cid : temp_cid
        })
        if(result.data.ret == 'Y'){
            gateData = result.data.rows;
            const page = activePage;
            const pageCurrent = pagiarray(gateData,page,pageSize);
            totalCount = gateData.length;
            setGateInfo(pageCurrent.data);
            console.log(result.data.rows);
        }else{
            alert(result.data.msg)
        }
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getGateInfo();
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getGateInfo();
            activePage = 1;
        }
    },[selectedCenter]);

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3>운영시간 관리</h3>
            <div className="content-component">
                <div className="content-header">
                <Button className="add-button" onClick={() => openPopup("add", {})}><DoorIcon /> 설정추가 </Button>
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
                </div>
                <div className="content-body">
                    <div className="table-header">
                    </div>
                    <div className="table-body cursor">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th style={{width:'160px'}}>센터명</th>
                                <th style={{width:'100px'}}>구분</th>
                                <th style={{width:'240px'}}>일자</th>
                                <th style={{width:'280px'}}>운영 시작시간</th>
                                <th style={{width:'280px'}}>운영 종료시간</th>
                                <th style={{width:'140px'}}>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                        {(totalCount === 0) &&
                                <tr>
                                    <td colSpan='20'>
                                        데이터가 없습니다.
                                    </td>
                                </tr>
                        }
                        {gateInfo.map(( item, index ) => {
                            const { cname, yoil, off_day, open, close, state } = item;
                            return(
                                <tr key={index} onClick={() => openPopup("edit", item)} >
                                    <td>{cname}</td>                                                                        
                                    <td>{yoil}</td>
                                    <td>{off_day ? moment(off_day).format('YYYY-MM-DD (dd)') : ''}</td>
                                    <td>{open}</td>
                                    <td>{close}</td>
                                    <td>
                                        {state == "Y" ? <FontAwesomeIcon icon={faToggleOn} className="open" style={{fontSize : 20}} />
                                        : <FontAwesomeIcon icon={faToggleOff} className="closed" style={{fontSize : 20}} />}
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </Table>
                    </div>
                    <Pagination
                        activePage={activePage}
                        itemsCountPerPage={pageSize}
                        pageRangeDisplayed={5}
                        totalItemsCount={totalCount}
                        itemClass="page-item"
                        linkClass="page-link"
                        onChange={handlePageChange}
					/>
                </div>
            </div>
            {showPopup ? 
            <PopupComponent
                data = {storage.popupData}
                mode = {storage.popupMode}
                closePopup={closePopup}
            />
            : null
            }
            </div>
            </div>
        </main>
    )
}

export default NewGate;